import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { MarketplaceProvider } from '../../providers/marketplace/marketplace';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { ToastProvider } from '../../providers/toast/toast';
import { AnimationGroupPlayer } from '@angular/animations/src/players/animation_group_player';
import { SingleMarketPlacePage } from '../single-market-place/single-market-place';
import { UtilService } from '../../services/util';
import { TranslateService } from '@ngx-translate/core';


/**
 * Generated class for the MarketplacereviewmodalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@IonicPage()
@Component({
  selector: 'page-marketplacereviewmodal',
  templateUrl: 'marketplacereviewmodal.html',
})
export class MarketplacereviewmodalPage {
  rating = "0";
  societyuuid:any;
  marketuuid:any;
  id:any;
  reviewsData :any;
  allUsersList:any;
  userList :any;
  userListShow : any;
  reportPage : any;

  constructor(public navCtrl: NavController,
    private viewCtrl: ViewController,
    private translate: TranslateService,
    private toast: ToastProvider,
    private util: UtilService,
    private marketplaceprovider: MarketplaceProvider,
     public navParams: NavParams) {

      this.userList = this.navParams.get("userList");
      // this.userList.forEach(element => {
      //   this.userListShow[element.id] = element;
      // });
      console.log(this.userList);
      this.reportPage = this.navParams.get('report_page')
      this.navCtrl = this.navParams.get('parentPageNav');
      this.societyuuid = this.navParams.get('societyUUID');
      this.marketuuid = this.navParams.get('marketUUID');
      this.id = this.navParams.get('ID');
      if(this.reportPage == 'Feedback'){
      this.marketplaceprovider.getItemReviews(this.id).then(val => {
          this.reviewsData =val['data'];
      });
    }

  }

  starClicked(num: number) {
    num++;
    this.rating = num.toString();
    console.log(this.rating);
  }

  nonStarClicked(num: number) {
    let temp = +this.rating;
    temp = temp + num + 1;
    this.rating = temp.toString();
    console.log(this.rating);
  }

  getRating(rating: string) {
    return Array(+rating);
  }

  getNonRating(rating: string) {
    return Array(5 - (+rating));
  }

  dismiss() {
   this.viewCtrl.dismiss();
 
  }


  onSubmitReview(feedback) {
    console.log(feedback)
    this.marketplaceprovider.review(feedback, this.rating, this.societyuuid, this.marketuuid, this.id).then(val => {
    this.toast.presentToast(val.message);
    if(val.status == 'success' ){
      console.log(val)
      feedback = '';
      this.dismiss();
    }
    });
  }

  onSubmitAbuse(abuse){
    console.log(abuse)
    this.marketplaceprovider.abuse(abuse,this.societyuuid,this.id).then(val =>{
      this.toast.presentToast(val.message);
      if(val.status == 'success'){
        this.dismiss();
      }
    })
  }
  

  ionViewDidLoad() {
    console.log('ionViewDidLoad MarketplacereviewmodalPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/marketplacereviewmodal/marketplacereviewmodal.ts